import Cookies from 'js-cookie';
import { featureEnabled } from 'lib/helpers';

export const getCurPopCount = () => parseInt(Cookies.get('pop_count'), 10) || 0;

export const hasHitDownloadLimit = ({ useHighLimit = false } = {}) => {
  if (document.body.dataset.userIsPro === 'true') {
    return false;
  }

  const currCount = getCurPopCount();

  if (useHighLimit) {
    if (featureEnabled('download-limit-10')) {
      return currCount >= 10;
    }

    return false;
  }

  return currCount >= 3;
};

// eslint-disable-next-line arrow-body-style
export const showDLLimitModal = ({ useHighLimit = false } = {}) => {
  return hasHitDownloadLimit({ useHighLimit });
};
